// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._x3do18ew{border-top:var(--_m6cf7x)}._16jlidpf{flex-grow:0}
._16qs4j53{box-shadow:var(--_cfawkn)}
._1o9zidpf{flex-shrink:0}
._i0dl1wug{flex-basis:auto}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/emoji/dist/esm/components/picker/EmojiPickerFooter.compiled.css"],"names":[],"mappings":";AACA,WAAW,yBAAyB,CAAC,WAAW,WAAW;AAC3D,WAAW,yBAAyB;AACpC,WAAW,aAAa;AACxB,WAAW,eAAe","sourcesContent":["\n._x3do18ew{border-top:var(--_m6cf7x)}._16jlidpf{flex-grow:0}\n._16qs4j53{box-shadow:var(--_cfawkn)}\n._1o9zidpf{flex-shrink:0}\n._i0dl1wug{flex-basis:auto}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
